export enum OSTYPES {
    WINDOWS = 'Windows',
    IOS = 'iOS',
    ANDROID = 'Android',
    MACOS = 'Mac OS',
}
